import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Box, visuallyHidden } from 'bonfire-kindling';

import DashboardOverviewMetrics from './DashboardOverviewMetrics';
import DashboardOverviewContent from './DashboardOverviewContent';

const DashboardOverview = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ my: 4, px: 2 }}>
      <Typography component="h1" style={visuallyHidden}>
        {t('dashboard.overview.title')}
      </Typography>
      <DashboardOverviewMetrics />
      <DashboardOverviewContent />
    </Box>
  );
};

export default DashboardOverview;
